import { useRef, useState, useEffect } from "react";
import classNames from "classnames";
import styles from "./AddSummaryModal.module.css";
import Button from "shared/Button";
import Modal from "ManagementTeam/Shared/Modal";
import ModalCard from "ManagementTeam/Shared/ModalCard";
import Input from "shared/@forms/Input";
import ModalActionBar from "shared/ModalActionBar";
import PDF from "./PDF.png";
import { useLocation } from "react-router-dom";
import Toggler from "ManagementTeam/Shared/Toggler";
import DatePickerCalendar from "ManagementTeam/CalendarPage/DatePickerCalendar";
import DatePicker from "ManagementTeam/Shared/DatePicker";
import moment from "moment";
import { usePublishSummary } from "../useSummaries";
import { nanoid } from "nanoid";

const _ = require("lodash");

/**
 * Interactive component. A button that allows the user to reset their vote on a decision item.
 */
const timeId = () => new Date().getTime();
export function AddSummaryModal({
  isOpen,
  onClose,
  onSave,
  onSaveDraft,
  summary,
}) {
  const options = [
    "March 23 & 24, 2022",
    "June 8, 2022",
    "September 14, 2022",
    "December 14, 2022",
    "March 15 & 16, 2023",
  ];
  const id = nanoid();

  const filePicker = useRef(null);
  const [documentTitle, setDocumentTitle] = useState("");
  const [fileName, setFileName] = useState("");
  const [documentItem, setDocumentItem] = useState(null);
  const [dateOneCalendarOpen, setDateOneCalendarOpen] = useState(false);
  const todaysDate = new Date();
  const [date, setDate] = useState(
    summary
      ? moment(summary.submittedOn).format("M.D.YY")
      : todaysDate.getUTCMonth() +
          1 +
          "." +
          todaysDate.getUTCDate() +
          "." +
          (todaysDate.getUTCFullYear() - 2000)
  );
  const location = useLocation();
  const publishSummary = usePublishSummary();

  let meetingType;
  if (location.pathname.split("/")[1] === "executive-committee") {
    meetingType = "EC";
  } else {
    meetingType = "MT";
  }

  useEffect(() => {
    if (summary) {
      if (
        summary?.files &&
        summary?.files?.length > 0 &&
        !_.isEmpty(summary.files[0])
      ) {
        setDocumentItem({
          files: summary.files,
          isDownloadable: summary.isDownloadable,
        });
        setFileName(summary.files[0].name);
      }
      if (summary.name) setDocumentTitle(summary.name);
      if (summary.date) setDate(formatDate(new Date(summary.date)));
      else {
        setDate(formatDate(new Date()));
      }
    }
  }, [summary]);
  const handleSave = () => {
    const data = {
      name: documentTitle,
      meetingType: meetingType,
      files:
        documentItem?.files && documentItem?.files.length > 0
          ? documentItem.files[0]
          : null,
      isDraft: false,
      id: summary ? summary.id : "",
      isDownloadable:
        documentItem?.isDownloadable !== null &&
        documentItem?.isDownloadable !== undefined
          ? documentItem.isDownloadable
          : null,
      date: new Date(date.replaceAll(".", "/")).toISOString(),
    };
    onSave(data);
    setDocumentTitle("");
  };

  const handleDraft = () => {
    const data = {
      name: documentTitle,
      meetingType: meetingType,
      files:
        documentItem?.files && documentItem?.files.length > 0
          ? documentItem.files[0]
          : null,
      isDraft: true,
      id: summary ? summary.id : "",
      isDownloadable: documentItem?.isDownloadable
        ? documentItem.isDownloadable
        : null,
      date: new Date(date.replaceAll(".", "/")).toISOString(),
    };
    onSaveDraft(data);
  };
  const handleToggleDownloadable = () => {
    if (!documentItem) {
      return;
    }
    setDocumentItem({
      ...documentItem,
      isDownloadable: !documentItem.isDownloadable,
    });
  };
  const toggleDateOneCalendar = () => {
    if (dateOneCalendarOpen) {
      setDateOneCalendarOpen(false);
    } else {
      setDateOneCalendarOpen(true);
    }
  };
  const formatDate = (date) => {
    return (
      date.getUTCMonth() +
      1 +
      "." +
      date.getUTCDate() +
      "." +
      (date.getUTCFullYear() - 2000)
    );
  };
  const onPublish = () => {
    publishSummary
      .mutateAsync({
        id: summary.id,
        published: true,
      })
      .then(() => {
        onClose();
      });
  };

  const onUnpublish = () => {
    publishSummary
      .mutateAsync({
        id: summary.id,
        published: false,
      })
      .then(() => {
        onClose();
      });
  };
  const modalActionBarChildren = (
    <div className={styles.actionBar}>
      <Button
        children={"Cancel"}
        className={styles.cancelButton}
        onClick={() => {
          setDocumentTitle("");
          setDocumentItem(null);
          onClose();
        }}
      />
      <Button
        children={"Save"}
        className={styles.saveButton}
        disabled={!documentTitle}
        onClick={() => handleSave()}
      />
      <Button
        children={"Save as Draft"}
        className={styles.draftButton}
        disabled={!documentTitle}
        onClick={() => handleDraft()}
      />
    </div>
  );
  const modalChildren = (
    <div className={styles.modalContainer}>
      <div className={styles.actionBarContainer}>
        <div className={styles["button-bar"]}>
          {summary?.id ? (
            <ModalActionBar
              children={
                <>
                  <button
                    type="button"
                    onClick={onUnpublish}
                    className={
                      summary.isDraft
                        ? styles.unpublishedButton
                        : styles.activeButton
                    }
                    disabled={summary.isDraft}
                  >
                    Unpublished
                  </button>
                  <button
                    type="button"
                    onClick={onPublish}
                    className={
                      !summary.isDraft
                        ? styles.publishedButton
                        : styles.activeButton
                    }
                    disabled={!summary.isDraft}
                  >
                    Published
                  </button>
                </>
              }
            />
          ) : (
            <div></div>
          )}
        </div>
        <ModalActionBar children={modalActionBarChildren} />
      </div>
      <ModalCard
        className={styles.disableScroll}
        children={
          <div className={styles.container}>
            <div className={styles.docInfoSection}>
              <span className={styles.meetingTitle}>Date</span>
              <div className={styles.select}>
                <div>
                  <div
                    className={classNames(
                      styles.dateOneCalendar,
                      !dateOneCalendarOpen && styles.displayNone
                    )}
                  >
                    <DatePickerCalendar
                      selectedDate={date ? date : formatDate(new Date())}
                      changeSelectedDate={(e) =>
                        setDate(formatDate(new Date(e)))
                      }
                    />
                  </div>
                  <DatePicker
                    dateString={date ? date : formatDate(new Date())}
                    setDate={setDate}
                    toggleCalendar={toggleDateOneCalendar}
                  />
                </div>
              </div>

              <div className={styles.docTitleInputSection}>
                <span className={styles.documentTitle}>Document Title</span>
                <Input
                  type="text"
                  className={styles.input}
                  placeholder={"Document Title"}
                  value={documentTitle}
                  onChange={(e) => setDocumentTitle(e.target.value)}
                />
              </div>
            </div>
            <div className={styles.docInfoSection}>
              <span className={styles.documentsSectionTitle}>Documents</span>
              {documentItem && (
                <div className={styles.documentsItemContainer}>
                  <div className={styles.uploadContainer}>
                    <div className={styles.pdfSection}>
                      <img src={PDF} className={styles.pdfIcon} />
                      <div className={styles.pdfTitle}>
                        {fileName ? fileName : documentTitle}
                      </div>
                    </div>

                    <Button
                      children={"Remove"}
                      className={styles.removeButton}
                      onClick={() => {
                        setDocumentItem(null);
                      }}
                    />
                  </div>
                  <div className={styles.documentsDownload}>
                    <span>Document is Downloadable</span>
                    <div className={styles.documentsDownloadToggle}>
                      <Toggler
                        visible={true}
                        onChange={() => handleToggleDownloadable()}
                        toggled={documentItem.isDownloadable}
                        color={
                          documentItem.isDownloadable ? "#39B54A" : "#D3D3D3"
                        }
                        key={id}
                      />
                    </div>
                  </div>
                  <div className={styles["documents-line"]} />
                </div>
              )}
              {!documentItem && (
                <>
                  <Button
                    children={"ADD"}
                    className={styles.addButton}
                    onClick={() => {
                      filePicker.current.click();
                    }}
                  />
                  <input
                    className={styles.fileInput}
                    ref={filePicker}
                    accept=".pdf"
                    type="file"
                    id="myFile"
                    name="filename"
                    data-testid="input"
                    onInput={(e) => {
                      if (e.target.files) {
                        setFileName(e.target.files[0].name);

                        let selectedFile = e.target.files;
                        const fileName = filePicker.current.value.split(".");

                        if (fileName[fileName.length - 1] === "pdf") {
                          var file = null;
                          let fileToLoad = selectedFile[0];
                          let fileReader = new FileReader();
                          fileReader.onload = function (fileLoadedEvent) {
                            file = fileLoadedEvent.target.result;
                            // Print data in console
                            setDocumentItem({
                              ...documentItem,
                              files: [
                                {
                                  name: fileName[0].replace(/^.*[\\/]/, ""),
                                  data: file,
                                  mimetype: "pdf",
                                },
                              ],
                              isDownloadable: true,
                            });
                          };

                          // Convert data to base64
                          fileReader.readAsDataURL(fileToLoad);
                        } else {
                          alert("File Format not PDF");
                        }
                        filePicker.current.value = "";
                      }
                    }}
                  />
                </>
              )}
            </div>
          </div>
        }
      />
    </div>
  );

  return (
    <>
      <Modal isOpen={isOpen} children={modalChildren} />
    </>
  );
}

AddSummaryModal.propTypes = {};
